import { ReactComponent as GoogleIcon } from 'assets/icons/social/google.svg';
import { Button } from 'components/ui/button';
import { Typography } from 'components/ui/typography';
import { RegisterFormState } from '.';
import { trackSegmentEvent } from 'app/utils';
import { SOURCE, ACTION } from 'app/analytics';
import { useState } from 'react';
import { Input } from 'components/ui/input';
import { addProtocolIfNotPresent } from 'utils/addProtocolIfNotPresent';
import { env } from 'config/env';

interface GoogleSignUpFlowProps {
  setFormState: (state: RegisterFormState) => void;
  signInOrRegisterWithGoogle: (website?: string) => Promise<boolean>;
  onRegistrationSuccess: () => void;
}

export function GoogleSignUpFlow({
  setFormState,
  signInOrRegisterWithGoogle,
  onRegistrationSuccess,
}: GoogleSignUpFlowProps) {
  const [website, setWebsite] = useState<string>('');

  // Register with Google account, or sign in if account already exists
  async function registerWithGoogle(event: React.FormEvent<HTMLFormElement>) {
    event.preventDefault();

    // Pass the website so we can save it to the user's Firestore doc after the Google auth flow
    const didRegister = await signInOrRegisterWithGoogle(website);

    trackSegmentEvent(SOURCE.SIGNUP_FORM, ACTION.CLICK, 'register_with_google_button');

    if (didRegister) {
      onRegistrationSuccess();
      window.dataLayer.push({
        event: 'account_signup_success',
        environment: env.VITE_NODE_ENV,
      });
    }
  }

  return (
    <>
      <form className="sign-up-form" onSubmit={registerWithGoogle}>
        <Typography variant="body" as="p" className="text-left">
          Almost there! Please enter your company website to get started with Rye 👇
        </Typography>

        <Input
          className="sign-up-input"
          type="url"
          placeholder="Website"
          value={website}
          onBlur={() => setWebsite(addProtocolIfNotPresent(website))}
          onChange={(e) => setWebsite(e.target.value.trim())}
          required
        />

        <Button type="submit" variant="outline" className="sign-up-google">
          <GoogleIcon /> Complete Google sign-up
        </Button>
      </form>

      <Typography variant="link" asChild>
        <a className="back-link" onClick={() => setFormState(RegisterFormState.INITIAL)}>
          &#8592; Back to email sign-up
        </a>
      </Typography>
    </>
  );
}
